(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  window.wf_hero_params = {
    lazyLoad: 'progressive',
    infinite: true,
    arrows: false,
    dots: false,
    useAutoplayToggleButton: false,
    rows: 0
  }

  if (Shopify.designMode) {
    $(function() {
      $(document).on('shopify:section:load shopify:section:reorder shopify:section:unload', function(evt) {
        process_slider(evt, ' .hero-slider', wf_hero_params);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-slider"] && !Shopify.designMode) return;
  try {
    
  window.wf_product_params = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: false,
    rows: 0,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: false,
          dots: true
        }
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
          dots: true
        }
      }, {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true
        }
      }
    ]
  }

  if (Shopify.designMode) {
    $(function () {
      $(document).on('shopify:section:load shopify:section:reorder shopify:section:unload', function (evt) {
        process_slider(evt, ' .product-slider', wf_product_params);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  window.wf_product_params = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: true,
    dots: true,
    rows: 0,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
          dots: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
          dots: true
        }
      }
    ]
  }

  if (Shopify.designMode) {
    $(function() {
      $(document).on('shopify:section:load shopify:section:reorder shopify:section:unload', function(evt) {
        process_slider(evt, ' .product-slider', wf_product_params);
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
